var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "EditWorkflow" } }, [
    _c("div", { staticClass: "wrapper" }, [
      _c("div", { staticClass: "toolbar" }, [
        _c(
          "div",
          { staticClass: "left" },
          [
            _c(
              "IconButton",
              {
                attrs: {
                  "on-click": function () {
                    return _vm.$router.push("/tasks")
                  },
                },
              },
              [
                _c("span", { staticClass: "material-icons" }, [
                  _vm._v(" chevron_left "),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "icon-container" },
              [_c("WorkflowIcon")],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "name" }, [
              _vm._v(
                _vm._s(_vm.$t("task.workflow")) +
                  ": " +
                  _vm._s(_vm.selectedWorkflow.title)
              ),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "right" },
          [
            _c(
              "SupsisButton",
              {
                staticStyle: { cursor: "pointer" },
                on: {
                  click: function ($event) {
                    return _vm.$router.push({
                      path: "/tasks",
                      query: {
                        type: "kanban",
                        workflow: _vm.selectedWorkflow._id,
                      },
                    })
                  },
                },
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "center",
                      "align-items": "center",
                      gap: "5px",
                    },
                  },
                  [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v(" view_kanban "),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticStyle: { "font-weight": "bold" } }, [
                      _vm._v(_vm._s(_vm.$t("auto.board"))),
                    ]),
                  ]
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "channel-content" }, [
        _c(
          "div",
          { staticClass: "left" },
          [
            _c("SidebarChild", {
              attrs: {
                items: _vm.menuItems,
                "selected-item": _vm.type,
                focusActive: true,
              },
              on: {
                selected: function (i) {
                  return (_vm.type = i.key)
                },
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "page-content" }, [
          _vm.type === "detail"
            ? _c("div", [
                _c("div", { staticClass: "header" }, [
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("task.workflowDetail"))),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { padding: "20px 50px 5px 50px" } },
                  [
                    _c("WorkflowForm", {
                      attrs: { details: _vm.workflowDetails, editMode: true },
                      on: { "update-form": _vm.updateForm },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "end",
                      cursor: "pointer",
                      "margin-right": "30px",
                    },
                  },
                  [
                    _c(
                      "SupsisButton",
                      {
                        staticStyle: { "margin-top": "10px" },
                        on: { click: _vm.saveDetail },
                      },
                      [_vm._v(_vm._s(_vm.$t("auto.save")) + " ")]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.type === "permission"
            ? _c("div", [
                _c("div", { staticClass: "header" }, [
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("task.workflowPerm"))),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { padding: "20px 50px 5px 50px" } },
                  [
                    _c("PermissionWorkflow", {
                      attrs: { details: _vm.workflowDetails },
                      on: { "update-form": _vm.updatePermissions },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.type === "visibility"
            ? _c("div", [
                _c(
                  "div",
                  { staticStyle: { padding: "20px 50px 5px 50px" } },
                  [
                    _c("VisibilityWorkFlow", {
                      attrs: { details: _vm.workflowDetails },
                      on: { "update-form": _vm.updateForm },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "end",
                      cursor: "pointer",
                      "margin-right": "30px",
                    },
                  },
                  [
                    _c(
                      "SupsisButton",
                      {
                        staticStyle: { "margin-top": "10px" },
                        on: { click: _vm.saveDetail },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("message.save")) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.type === "done"
            ? _c(
                "div",
                [
                  _c("div", { staticClass: "header" }, [
                    _c("div", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.$t("message.completedTasks"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("DoneTask", { attrs: { details: _vm.workflowDetails } }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.type === "doneTaskSettings"
            ? _c(
                "div",
                [
                  _c("DoneTaskSettings", {
                    attrs: { details: _vm.workflowDetails },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.type === "task-module-rules"
            ? _c(
                "div",
                [
                  _c("TaskModuleRules", {
                    attrs: { "workflow-id": _vm.selectedWorkflow._id },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.type === "checklist-templates"
            ? _c(
                "div",
                [
                  _c("ChecklistTemplates", {
                    attrs: { "workflow-id": _vm.selectedWorkflow._id },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }